import React, { useEffect, useState, createContext, useContext } from 'react';
import { getCurrentUser, isLoggedIn, logoutUser } from '../utils/authUtils';
type AuthContextType = {
  isAuthenticated: boolean;
  userEmail: string | null;
  userRole: string | null;
  logout: () => void;
  setAuthenticated: (value: boolean) => void;
};
const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  userEmail: null,
  userRole: null,
  logout: () => {},
  setAuthenticated: () => {}
});
export const useAuth = () => useContext(AuthContext);
export const AuthProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [userEmail, setUserEmail] = useState<string | null>(null);
  const [userRole, setUserRole] = useState<string | null>(null);
  useEffect(() => {
    // Check if user is logged in on component mount
    if (isLoggedIn()) {
      const user = getCurrentUser();
      setIsAuthenticated(true);
      setUserEmail(user?.email || null);
      setUserRole(user?.role || null);
    }
  }, []);
  const logout = () => {
    logoutUser();
    setIsAuthenticated(false);
    setUserEmail(null);
    setUserRole(null);
  };
  const setAuthenticated = (value: boolean) => {
    setIsAuthenticated(value);
    // If we're setting to authenticated, also update user data
    if (value && isLoggedIn()) {
      const user = getCurrentUser();
      setUserEmail(user?.email || null);
      setUserRole(user?.role || null);
    }
  };
  return <AuthContext.Provider value={{
    isAuthenticated,
    userEmail,
    userRole,
    logout,
    setAuthenticated
  }} data-id="element-158">
      {children}
    </AuthContext.Provider>;
};